import React from 'react'
import Navbar from '../components/Navbar'
import FloatResume from '../components/FloatResume'
import MyProjects from '../components/MyProjects'

const Projects = () => {
  return (
    <div>
      <Navbar />
      <MyProjects />
      <FloatResume />
    </div>
  )
}

export default Projects
